<script setup lang="ts">

import { faArrowUpArrowDown, faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { FilterDateRange } from '@shared/ui/filters'
import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { AppInput } from '@shared/ui/inputs'
import { AppSelect } from '@shared/ui/selects'
import { MultiSelectSearchable } from '@shared/ui/fields'

import { useTasksKanbanFilters } from '../model/tasks-kanban-filters.hook'

defineOptions({
  name: 'TasksKanbanFilters',
})

const {
  filterResetKey,
  searchQuery,
  deadlineRange,
  resolvedAtRange,
  assigneeOptions,
  assigneeInitialValue,
  handleAssigneeSelected,
  taskTypeOptions,
  taskTypeInitialValue,
  handleTaskTypeSelected,
  priorityOptions,
  priorityInitialValue,
  handlePrioritySelected,
  activationTypeOptions,
  activationTypeInitialValue,
  handleActivationTypeSelected,
  alertTypeOptions,
  alertTypeInitialValue,
  handleAlertTypeSelected,
  ongoingOptions,
  ongoingValue,
  sortOptions,
  sortValue,
  handleSearch,
  handleClear,
} = useTasksKanbanFilters()
</script>

<template>
  <div class="tasks-kanban-filters">
    <div class="tasks-kanban-filters__main">
      <div
        :key="filterResetKey"
        class="tasks-kanban-filters__general"
      >
        <AppInput
          v-model="searchQuery"
          label="Search"
          placeholder="Name, email, phone, ID"
          @keyup:enter="handleSearch"
        />
        <FilterDateRange
          v-model="deadlineRange"
          label="Due date"
        />
        <FilterDateRange
          v-model="resolvedAtRange"
          label="Resolved at"
        />
        <MultiSelectSearchable
          :key="`assignee-${assigneeOptions.length}`"
          class="multiselect-assignee"
          label="Assignee"
          placeholder="All"
          :options="assigneeOptions"
          :value="assigneeInitialValue"
          :is-all-available="true"
          @selected="handleAssigneeSelected"
        />
        <MultiSelectSearchable
          :key="`task-type-${taskTypeOptions.length}`"
          class="multiselect-task-type"
          label="Type"
          placeholder="All"
          :options="taskTypeOptions"
          :value="taskTypeInitialValue"
          :is-all-available="true"
          @selected="handleTaskTypeSelected"
        />
        <MultiSelectSearchable
          :key="`priority-${priorityOptions.length}`"
          class="multiselect-priority"
          label="Priority"
          placeholder="All"
          :options="priorityOptions"
          :value="priorityInitialValue"
          :is-all-available="true"
          @selected="handlePrioritySelected"
        />
        <MultiSelectSearchable
          :key="`activation-type-${activationTypeOptions.length}`"
          class="multiselect-activation-type"
          label="Activation type"
          placeholder="All"
          :options="activationTypeOptions"
          :value="activationTypeInitialValue"
          :is-all-available="true"
          @selected="handleActivationTypeSelected"
        />
        <MultiSelectSearchable
          :key="`alert-type-${alertTypeOptions.length}`"
          class="multiselect-alert-type"
          label="Alert type"
          placeholder="All"
          :options="alertTypeOptions"
          :value="alertTypeInitialValue"
          :is-all-available="true"
          @selected="handleAlertTypeSelected"
        />
        <AppSelect
          v-model="ongoingValue"
          class="ongoing-select"
          label="Ongoing"
          placeholder="All"
          clearable
          :options="ongoingOptions"
        />
        <AppSelect
          v-model="sortValue"
          class="sort-select"
          label="Sort"
          placeholder="Sort"
          clearable
          :prepend-icon="faArrowUpArrowDown"
          :options="sortOptions"
        />
      </div>
      <div class="tasks-kanban-filters__controls">
        <BtnPrimary
          text="Search"
          @click="handleSearch"
        />
        <BtnIcon
          :icon="faFilterCircleXmark"
          color="red"
          tooltip-text="Clear filters"
          @click="handleClear"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TasksKanbanFilters.scss" />
